import React, { useEffect, useState } from 'react';
import { POSLayout } from './components/POSLayout';
import { OrderQueue, Order, OrderStatus, HistoryEvent } from './components/OrderQueue';
import { OrderDetails } from './components/OrderDetails';
import { OrderHistory } from './components/OrderHistory';
import { Toaster, toast } from 'sonner';
import { useScreenInit } from './useScreenInit.js';
const INITIAL_ORDERS: Order[] = [{
  id: 'ORD-7721',
  customerName: 'Khalid Mansour',
  itemsCount: 3,
  totalAmount: 245.5,
  status: 'Pending',
  channel: 'Website',
  paymentType: 'COD',
  createdAt: '2026-07-08 10:15 AM',
  slaMinutes: 8,
  priority: 'High',
  customerAddress: 'Building 42, Al-Olaya St, Riyadh 12211, Saudi Arabia',
  customerPhone: '+966 50 123 4567',
  customerCity: 'Riyadh',
  customerDistrict: 'Al-Olaya',
  customerAge: 34,
  customerGender: 'Male',
  isLoyaltyCustomer: true,
  loyaltyPointsUsed: 500,
  qitafAmount: 20.0,
  courierName: 'Aramex',
  discountAmount: 15.0,
  couponCode: 'WELCOME15',
  sourceOrderId: 'WEB-99281',
  requiresPrescription: true,
  prescriptionVerified: false,
  prescriptionImage: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=600&fit=crop',
  history: [{
    id: 'h1',
    timestamp: '2026-07-08 10:15 AM',
    status: 'Pending',
    message: 'Order received from Website',
    actor: 'System',
    actorName: 'Online Store'
  }]
}, {
  id: 'ORD-7722',
  customerName: 'Sara Al-Otaibi',
  itemsCount: 1,
  totalAmount: 120.0,
  status: 'Accepted',
  channel: 'Aggregator',
  paymentType: 'Prepaid',
  createdAt: '2026-07-08 10:20 AM',
  slaMinutes: 15,
  priority: 'Medium',
  customerAddress: 'Villa 12, Al-Malqa District, Riyadh 13521, Saudi Arabia',
  customerPhone: '+966 55 987 6543',
  customerCity: 'Riyadh',
  customerDistrict: 'Al-Malqa',
  customerAge: 28,
  customerGender: 'Female',
  isLoyaltyCustomer: false,
  courierName: 'SMSA Express',
  sourceOrderId: 'HG-88271',
  history: [{
    id: 'h1',
    timestamp: '2026-07-08 10:20 AM',
    status: 'Pending',
    message: 'Order received from Aggregator',
    actor: 'System',
    actorName: 'HungerStation'
  }, {
    id: 'h2',
    timestamp: '2026-07-08 10:25 AM',
    status: 'Accepted',
    message: 'Order accepted by pharmacist',
    actor: 'Pharmacist',
    actorName: 'Ahmed Al-Farsi'
  }]
}, {
  id: 'ORD-7723',
  customerName: 'Mohammed Rashid',
  itemsCount: 5,
  totalAmount: 450.75,
  status: 'Picking',
  channel: 'Website',
  paymentType: 'Prepaid',
  createdAt: '2026-07-08 09:45 AM',
  slaMinutes: 4,
  priority: 'High',
  customerAddress: 'Apt 402, Al-Nakheel Tower, Jeddah 23423, Saudi Arabia',
  customerPhone: '+966 54 321 0987',
  courierName: 'Careem Box',
  discountAmount: 25.0,
  couponCode: 'HEALTHY2026',
  sourceOrderId: 'WEB-99285',
  history: [{
    id: 'h1',
    timestamp: '2026-07-08 09:45 AM',
    status: 'Pending',
    message: 'Order received from Website',
    actor: 'System',
    actorName: 'Online Store'
  }, {
    id: 'h2',
    timestamp: '2026-07-08 09:50 AM',
    status: 'Accepted',
    message: 'Order accepted by pharmacist',
    actor: 'Pharmacist',
    actorName: 'Ahmed Al-Farsi'
  }, {
    id: 'h3',
    timestamp: '2026-07-08 09:55 AM',
    status: 'Picking',
    message: 'Pharmacist started picking items',
    actor: 'Pharmacist',
    actorName: 'Ahmed Al-Farsi'
  }]
}, {
  id: 'ORD-7726',
  customerName: 'Omar Farooq',
  itemsCount: 2,
  totalAmount: 180.0,
  status: 'Delivered',
  channel: 'Website',
  paymentType: 'Prepaid',
  createdAt: '2026-07-07 04:30 PM',
  slaMinutes: 0,
  priority: 'Medium',
  customerAddress: 'Al-Nuzha District, Riyadh',
  customerPhone: '+966 50 222 3333',
  sourceOrderId: 'WEB-99290',
  history: [{
    id: 'h1',
    timestamp: '2026-07-07 04:30 PM',
    status: 'Pending',
    message: 'Order received',
    actor: 'System',
    actorName: 'Online Store'
  }, {
    id: 'h2',
    timestamp: '2026-07-07 05:15 PM',
    status: 'Delivered',
    message: 'Order delivered successfully',
    actor: 'Driver',
    actorName: 'Sami'
  }]
}, {
  id: 'ORD-7727',
  customerName: 'Laila Hassan',
  itemsCount: 1,
  totalAmount: 55.0,
  status: 'Cancelled',
  channel: 'Aggregator',
  paymentType: 'COD',
  createdAt: '2026-07-07 02:00 PM',
  slaMinutes: 0,
  priority: 'Low',
  customerAddress: 'Al-Waha, Riyadh',
  customerPhone: '+966 55 444 5555',
  sourceOrderId: 'HG-88275',
  rejectionReason: 'Customer changed mind',
  history: [{
    id: 'h1',
    timestamp: '2026-07-07 02:00 PM',
    status: 'Pending',
    message: 'Order received',
    actor: 'System',
    actorName: 'HungerStation'
  }, {
    id: 'h2',
    timestamp: '2026-07-07 02:10 PM',
    status: 'Cancelled',
    message: 'Order cancelled: Customer changed mind',
    actor: 'Pharmacist',
    actorName: 'Ahmed Al-Farsi'
  }]
}, {
  id: 'ORD-8801',
  customerName: 'Sami Mansour',
  itemsCount: 1,
  totalAmount: 45.0,
  status: 'Picking',
  channel: 'Website',
  paymentType: 'Mada',
  createdAt: '2026-07-08 11:00 AM',
  slaMinutes: 25,
  priority: 'Medium',
  isPickup: true,
  otp: '5566',
  customerAddress: 'Self-Pickup at Olaya Branch',
  customerPhone: '+966 50 999 8888',
  customerCity: 'Riyadh',
  customerDistrict: 'Al-Olaya',
  customerAge: 42,
  customerGender: 'Male',
  isLoyaltyCustomer: true,
  loyaltyPointsUsed: 1200,
  walletAmount: 15.0,
  sourceOrderId: 'WEB-10050',
  history: [{
    id: 'h1',
    timestamp: '2026-07-08 11:00 AM',
    status: 'Pending',
    message: 'Order received for Self-Pickup',
    actor: 'System',
    actorName: 'Online Store'
  }, {
    id: 'h2',
    timestamp: '2026-07-08 11:05 AM',
    status: 'Accepted',
    message: 'Order accepted by pharmacist',
    actor: 'Pharmacist',
    actorName: 'Ahmed Al-Farsi'
  }]
}];
export function App() {
  const screenInit = useScreenInit();
  const [activeTab, setActiveTab] = useState(screenInit.activeTab || 'dashboard');
  const [orders, setOrders] = useState<Order[]>(INITIAL_ORDERS);
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(screenInit.selectedOrderId || null);
  useEffect(() => {
    if (screenInit.activeTab) setActiveTab(screenInit.activeTab);
    if (screenInit.selectedOrderId !== undefined) setSelectedOrderId(screenInit.selectedOrderId);
  }, [screenInit]);
  const selectedOrder = orders.find(o => o.id === selectedOrderId);
  const handleUpdateStatus = (orderId: string, newStatus: OrderStatus, updates?: Partial<Order>) => {
    const now = new Date().toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    setOrders(prev => prev.map(o => {
      if (o.id === orderId) {
        const newEvent: HistoryEvent = {
          id: Math.random().toString(36).substr(2, 9),
          timestamp: now,
          status: newStatus,
          message: `Status updated to ${newStatus}${updates?.rejectionReason ? `: ${updates.rejectionReason}` : ''}${updates?.holdReason ? `: ${updates.holdReason}` : ''}`,
          actor: 'Pharmacist',
          actorName: 'Ahmed Al-Farsi'
        };
        return {
          ...o,
          status: newStatus,
          previousStatus: newStatus === 'Held' ? o.status : o.previousStatus,
          ...updates,
          history: [...o.history, newEvent]
        };
      }
      return o;
    }));
    if (newStatus === 'Cancelled') {
      toast.error(`Order ${orderId} Cancelled: ${updates?.rejectionReason || 'No reason provided'}`);
    } else if (newStatus === 'Rejected') {
      toast.error(`Order ${orderId} Rejected`);
    } else if (newStatus === 'Held') {
      toast.warning(`Order ${orderId} Held: ${updates?.holdReason || 'No reason provided'}`);
    } else {
      toast.success(`Order ${orderId} status updated to ${newStatus}`);
    }
    // Auto-navigate back to queue if terminal states
    if (['Delivered', 'Cancelled', 'Rejected', 'Refunded'].includes(newStatus)) {
      setSelectedOrderId(null);
    }
  };
  return <POSLayout activeTab={activeTab} onTabChange={setActiveTab} data-id="element-0">
      <Toaster position="top-right" expand={true} richColors data-id="element-1" />

      {activeTab === 'dashboard' && !selectedOrderId && <OrderQueue orders={orders} onSelectOrder={order => setSelectedOrderId(order.id)} data-id="element-2" />}

      {activeTab === 'history' && !selectedOrderId && <OrderHistory orders={orders} onSelectOrder={order => setSelectedOrderId(order.id)} data-id="element-3" />}

      {selectedOrderId && selectedOrder && <OrderDetails order={selectedOrder} onBack={() => setSelectedOrderId(null)} onUpdateStatus={(status, updates) => handleUpdateStatus(selectedOrder.id, status, updates)} readOnly={activeTab === 'history'} onUpdatePaymentMethod={newMethod => {
      setOrders(prev => prev.map(o => o.id === selectedOrder.id ? {
        ...o,
        paymentType: newMethod
      } : o));
      toast.success(`Payment method updated to ${newMethod}`);
    }} initialShowRejectModal={screenInit.showRejectModal} initialIsBulkScanning={screenInit.isBulkScanning} initialConfirmItem={screenInit.confirmItem} initialIsWaitingConfirmation={screenInit.isWaitingConfirmation} initialShowPartialModal={screenInit.showPartialModal} initialScanningItem={screenInit.scanningItem} initialShowGlobalScanModal={screenInit.showGlobalScanModal} initialShowHoldModal={screenInit.showHoldModal} initialShowOtpModal={screenInit.showOtpModal} data-id="element-4" />}

      {!['dashboard', 'history'].includes(activeTab) && !selectedOrderId && <div className="flex flex-col items-center justify-center h-full text-slate-400 space-y-4" data-id="element-5">
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center" data-id="element-6">
            <span className="text-2xl font-bold" data-id="element-7">?</span>
          </div>
          <p className="font-medium" data-id="element-8">This module is under development.</p>
        </div>}
    </POSLayout>;
}